export default __webpack_public_path__ + "static/media/warningTransparentOrange.ea6410b1.svg";